/**
 * GSAP Plugins Initialization
 *
 * Registers GSAP plugins once globally to avoid registration issues
 * Must be imported before using ScrollTrigger or SplitText
 */

import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { SplitText } from "gsap/SplitText"

// Register plugins immediately when module loads
if (typeof window !== "undefined") {
  // Directly register without checking - GSAP handles duplicate registration internally
  try {
    gsap.registerPlugin(ScrollTrigger, SplitText)
    console.log("GSAP plugins registered: ScrollTrigger, SplitText")
  } catch (e) {
    console.warn("GSAP plugin registration warning:", e)
  }
}

// Export for use in components
export { gsap, ScrollTrigger, SplitText }

// Helper to ensure plugins are registered (call before animations if needed)
export function ensureGSAPPluginsRegistered() {
  if (typeof window !== "undefined") {
    try {
      gsap.registerPlugin(ScrollTrigger, SplitText)
    } catch (e) {
      // Ignore - already registered
    }
  }
}
